// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Icon = require("./BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("./BrowserComponents_Text.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");
var BrowserComponents_FlexColumn = require("./BrowserComponents_FlexColumn.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: /* [] */0
    });

function text(textColor, size, styleType, theme) {
  var arg = BrowserStyle.Input.sizeToTitleFontSize(size);
  var arg$1 = function (param, param$1) {
    return BrowserStyle.withFont(param, param$1, arg, /* Semibold */1);
  };
  return Curry._1(BrowserStyle.merge, {
              hd: Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined, undefined), {
                        hd: BrowserStyle.color(BrowserStyle.Input.getTitleColor(theme, styleType)),
                        tl: {
                          hd: BrowserStyle.textAlign("left"),
                          tl: /* [] */0
                        }
                      })),
              tl: {
                hd: Relude_Option.fold(Curry._1(BrowserStyle.style, /* [] */0), (function (textColor) {
                        return Curry._1(BrowserStyle.style, {
                                    hd: BrowserStyle.color(textColor),
                                    tl: /* [] */0
                                  });
                      }), textColor),
                tl: /* [] */0
              }
            });
}

var Styles = {
  container: container,
  text: text
};

function BrowserComponents_Field$Title(Props) {
  var className = Props.className;
  var color = Props.color;
  var containerClassName = Props.containerClassName;
  var icon = Props.icon;
  var noSpacerOpt = Props.noSpacer;
  var sizeOpt = Props.size;
  var styleTypeOpt = Props.styleType;
  var themeOpt = Props.theme;
  var title = Props.title;
  var noSpacer = noSpacerOpt !== undefined ? noSpacerOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : /* Medium */2;
  var styleType = styleTypeOpt !== undefined ? styleTypeOpt : /* Enabled */({
        _0: /* Blurred */0,
        _1: /* Waiting */0
      });
  var theme = themeOpt !== undefined ? themeOpt : /* LightBackground */0;
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_FlexRow.make, {
                  className: BrowserStyle.Utils.extendBaseStyle(container, containerClassName),
                  children: null
                }, Relude_Option.fold(null, (function (icon) {
                        return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Icon.make, {
                                        color: Relude_Option.fold(BrowserStyle.Input.getTitleColor(theme, styleType), Relude_Globals.id, color),
                                        icon: {
                                          TAG: /* Small */1,
                                          _0: icon
                                        },
                                        size: /* Small */1
                                      }), React.createElement(BrowserComponents_Spacer.make, {
                                        size: /* Small */3
                                      }));
                      }), icon), React.createElement(BrowserComponents_Text.make, {
                      className: BrowserStyle.Utils.extendBaseStyle(text(color, size, styleType, theme), className),
                      children: title
                    })), noSpacer ? null : React.createElement(BrowserComponents_Spacer.make, {
                    size: /* Small */3
                  }));
}

var Title = {
  Styles: Styles,
  make: BrowserComponents_Field$Title
};

var icon = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(1.0)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(1.0)),
        tl: /* [] */0
      }
    });

var text$1 = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Small */2, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Red */5,
                _0: /* Medium */2
              }),
          tl: /* [] */0
        }));

var Styles$1 = {
  icon: icon,
  text: text$1
};

function BrowserComponents_Field$ErrorMessage(Props) {
  var isIconVisibleOpt = Props.isIconVisible;
  var message = Props.message;
  var isIconVisible = isIconVisibleOpt !== undefined ? isIconVisibleOpt : true;
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Small */3
                }), React.createElement(BrowserComponents_FlexRow.make, {
                  children: null
                }, isIconVisible ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Icon.make, {
                            className: icon,
                            color: {
                              TAG: /* Red */5,
                              _0: /* Medium */2
                            },
                            icon: {
                              TAG: /* Small */1,
                              _0: {
                                TAG: /* Status */8,
                                _0: /* AlertTriangle */1
                              }
                            }
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Small */3
                          })) : null, React.createElement(BrowserComponents_Text.make, {
                      className: text$1,
                      children: message
                    })));
}

var ErrorMessage = {
  Styles: Styles$1,
  make: BrowserComponents_Field$ErrorMessage
};

function bottomActions(styleType, size) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.backgroundColor(BrowserStyle.Input.getBackgroundColor(styleType)),
              tl: {
                hd: BrowserStyle.borderBottomLeftRadius(BrowserStyle.Input.borderRadius),
                tl: {
                  hd: BrowserStyle.borderBottomRightRadius(BrowserStyle.Input.borderRadius),
                  tl: {
                    hd: BrowserStyle.Input.sizeToPaddingStyle(size),
                    tl: /* [] */0
                  }
                }
              }
            });
}

function container$1(size, styleType) {
  var arg = BrowserStyle.Input.sizeToFontSize(size);
  return Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, arg, undefined)({
                  hd: BrowserStyle.color(BrowserStyle.Input.getTextColor(styleType)),
                  tl: {
                    hd: Css.unsafe("cursor", BrowserStyle.Input.isDisabled(styleType) ? "not-allowed" : "inherit"),
                    tl: {
                      hd: BrowserStyle.display(BrowserStyle.flexBox),
                      tl: {
                        hd: BrowserStyle.flexDirection(BrowserStyle.column),
                        tl: /* [] */0
                      }
                    }
                  }
                }));
}

function fieldWrapper(hasBottomActions, styleType, size, theme) {
  return Curry._1(BrowserStyle.merge, {
              hd: Curry._1(BrowserStyle.style, {
                    hd: BrowserStyle.alignItems(BrowserStyle.center),
                    tl: {
                      hd: BrowserStyle.backgroundColor(BrowserStyle.Input.getBackgroundColor(styleType)),
                      tl: {
                        hd: BrowserStyle.border(BrowserStyle.Input.getBorderSize(styleType), BrowserStyle.solid, BrowserStyle.Input.getBorderColor(theme, styleType)),
                        tl: {
                          hd: BrowserStyle.borderRadius(BrowserStyle.Input.borderRadius),
                          tl: {
                            hd: BrowserStyle.margin(styleType && (styleType._0 || typeof styleType._1 !== "number") ? BrowserStyle.px(-1) : BrowserStyle.zero),
                            tl: {
                              hd: BrowserStyle.Input.sizeToPaddingStyle(size),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }),
              tl: {
                hd: hasBottomActions ? Curry._1(BrowserStyle.style, {
                        hd: BrowserStyle.borderBottomLeftRadius(BrowserStyle.zero),
                        tl: {
                          hd: BrowserStyle.borderBottomRightRadius(BrowserStyle.zero),
                          tl: /* [] */0
                        }
                      }) : Curry._1(BrowserStyle.style, /* [] */0),
                tl: /* [] */0
              }
            });
}

function hint(styleType) {
  return Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Medium */3, undefined)({
                  hd: BrowserStyle.color(BrowserStyle.Input.getHintColor(styleType)),
                  tl: {
                    hd: BrowserStyle.textAlign("left"),
                    tl: /* [] */0
                  }
                }));
}

var inputWrapper = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.minWidth(BrowserStyle.zero),
      tl: {
        hd: BrowserStyle.textAlign("left"),
        tl: {
          hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
          tl: /* [] */0
        }
      }
    });

function label(styleType, size, theme) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.backgroundColor(BrowserStyle.Input.getBackgroundColor(styleType)),
              tl: {
                hd: BrowserStyle.borderBottom(BrowserStyle.rem(0.0625), BrowserStyle.solid, BrowserStyle.Input.getBorderColor(theme, styleType)),
                tl: {
                  hd: BrowserStyle.Input.sizeToPaddingStyle(size),
                  tl: /* [] */0
                }
              }
            });
}

var Styles$2 = {
  bottomActions: bottomActions,
  container: container$1,
  fieldWrapper: fieldWrapper,
  hint: hint,
  inputWrapper: inputWrapper,
  label: label
};

function make(fieldContainerDomRef, param) {
  return {
          fieldContainerDomRef: fieldContainerDomRef,
          onBlur: param.onBlur,
          onFocus: param.onFocus,
          styleType: param.styleType
        };
}

var InputFieldRenderPayload = {
  make: make
};

function $$static(param_0) {
  return {
          TAG: /* Static */0,
          _0: param_0
        };
}

function input(param_0) {
  return {
          TAG: /* Input */1,
          _0: param_0
        };
}

function BrowserComponents_Field(Props) {
  var bottomActions$1 = Props.bottomActions;
  var className = Props.className;
  var containerClassName = Props.containerClassName;
  var children = Props.children;
  var disabledOpt = Props.disabled;
  var hint$1 = Props.hint;
  var iconColor = Props.iconColor;
  var iconLeft = Props.iconLeft;
  var iconRight = Props.iconRight;
  var label$1 = Props.label;
  var onBlur = Props.onBlur;
  var onFocus = Props.onFocus;
  var sizeOpt = Props.size;
  var themeOpt = Props.theme;
  var title = Props.title;
  var titleAndFieldContainerClassName = Props.titleAndFieldContainerClassName;
  var titleColor = Props.titleColor;
  var titleIcon = Props.titleIcon;
  var titleSize = Props.titleSize;
  var validationStatus = Props.validationStatus;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : /* Medium */2;
  var theme = themeOpt !== undefined ? themeOpt : /* LightBackground */0;
  var hookPayload = Curry._2(BrowserStyle.Input.useInput(onFocus)(disabled), onBlur, validationStatus);
  var styleType = hookPayload.styleType;
  var match = ReactIO.useDomRef(undefined);
  var parsedValidationStatus = Curry._1(BrowserStyle.Input.ValidationStatus.parseValidationStatus, validationStatus);
  var iconSize = BrowserStyle.Input.sizeToIconSize(size);
  var iconColor$1 = Relude_Option.getOrElse(styleType ? (
          styleType._0 ? ({
                TAG: /* Teal */6,
                _0: /* Medium */2
              }) : (
              typeof styleType._1 === "number" ? ({
                    TAG: /* Grey */2,
                    _0: /* Dark */1
                  }) : ({
                    TAG: /* Red */5,
                    _0: /* Medium */2
                  })
            )
        ) : ({
            TAG: /* Grey */2,
            _0: /* Light */3
          }), iconColor);
  var tmp = {
    children: null
  };
  if (titleAndFieldContainerClassName !== undefined) {
    tmp.className = Caml_option.valFromOption(titleAndFieldContainerClassName);
  }
  var tmp$1;
  tmp$1 = children.TAG === /* Static */0 ? children._0 : Curry._1(children._0, make(match[0], hookPayload));
  return React.createElement("label", {
              className: BrowserStyle.Utils.extendBaseStyle(container$1(size, styleType), className)
            }, React.createElement(BrowserComponents_FlexColumn.make, tmp, Relude_Option.fold(null, (function (title) {
                        var tmp = {
                          size: Relude_Option.getOrElse(size, titleSize),
                          styleType: styleType,
                          theme: theme,
                          title: title
                        };
                        if (titleColor !== undefined) {
                          tmp.color = Caml_option.valFromOption(titleColor);
                        }
                        if (titleIcon !== undefined) {
                          tmp.icon = Caml_option.valFromOption(titleIcon);
                        }
                        return React.createElement(BrowserComponents_Field$Title, tmp);
                      }), Curry._2(Relude_Option.flatMap, Relude_String.toNonWhitespace, title)), Relude_Option.fold(null, (function (label$2) {
                        return React.createElement(BrowserComponents_FlexColumn.make, {
                                    className: label(styleType, size, theme),
                                    children: label$2
                                  });
                      }), label$1), React.createElement(BrowserComponents_FlexRow.make, {
                      className: BrowserStyle.Utils.extendBaseStyle(fieldWrapper(Relude_Option.isSome(bottomActions$1), styleType, size, theme), Relude_Option.apply(containerClassName, Relude_Option.pure(styleType))),
                      children: null,
                      ref: match[1]
                    }, Relude_Option.fold(null, (function (icon) {
                            return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Icon.make, {
                                            color: iconColor$1,
                                            icon: {
                                              TAG: /* Small */1,
                                              _0: icon
                                            },
                                            size: iconSize
                                          }), React.createElement(BrowserComponents_Spacer.make, {
                                            size: /* Small */3
                                          }));
                          }), iconLeft), React.createElement(BrowserComponents_FlexColumn.make, {
                          className: inputWrapper,
                          children: tmp$1
                        }), Relude_Option.fold(null, (function (icon) {
                            return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                            size: /* Small */3
                                          }), React.createElement(BrowserComponents_Icon.make, {
                                            color: iconColor$1,
                                            icon: {
                                              TAG: /* Small */1,
                                              _0: icon
                                            },
                                            size: iconSize
                                          }));
                          }), iconRight))), Relude_Option.fold(null, (function (actions) {
                    return React.createElement(BrowserComponents_FlexColumn.make, {
                                className: bottomActions(styleType, size),
                                children: actions
                              });
                  }), bottomActions$1), Relude_Option.fold(null, (function (message) {
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Small */3
                                  }), React.createElement(BrowserComponents_Text.make, {
                                    className: hint(styleType),
                                    children: message
                                  }));
                  }), Curry._2(Relude_Option.flatMap, Relude_String.toNonWhitespace, Relude_Option.alt(Curry._1(BrowserStyle.Input.ValidationStatus.getError, parsedValidationStatus), hint$1))));
}

var make$1 = BrowserComponents_Field;

exports.Title = Title;
exports.ErrorMessage = ErrorMessage;
exports.Styles = Styles$2;
exports.InputFieldRenderPayload = InputFieldRenderPayload;
exports.$$static = $$static;
exports.input = input;
exports.make = make$1;
/* container Not a pure module */
